import React, { useState, useEffect } from 'react';
import useIsLogged from '../utils/useIsLogged';
import { isCampaignActive } from '../utils/dateUtils';

// Kill switch: popup deactivated on request (2026-07-29). Set to false to bring it back.
const IS_DEACTIVATED = true;

const TrackingFeatureWarning = ({ className = '' }) => {
  const [isVisible, setIsVisible] = useState(true);
  const isLogged = useIsLogged();

  const STORAGE_KEY = 'trackingFeatureWarningClosed';

  useEffect(() => {
    // Check if the warning was already closed
    const wasClosed = sessionStorage.getItem(STORAGE_KEY);
    if (wasClosed === 'true') {
      setIsVisible(false);
    }
  }, []);

  // Hide this popup during the Black Friday campaign
  const isCampaignCurrentlyActive = isCampaignActive();

  if (IS_DEACTIVATED || !isVisible || !isLogged || isCampaignCurrentlyActive) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    // Save to session storage that the warning was closed
    sessionStorage.setItem(STORAGE_KEY, 'true');
  };

  return (
    <div className={`tracking-feature-warning ${className}`}>
      <div className="tracking-feature-warning__header">
        <h4 className="tracking-feature-warning__title">
          Urmărire colet
        </h4>
        <button
          onClick={handleClose}
          className="tracking-feature-warning__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="tracking-feature-warning__content">
        <p>Am lansat funcția Urmărire colet, prin care poți verifica statusul livrărilor direct în platformă.</p>
        <p>⚠️ În această etapă pilot, datele afișate sunt corecte doar pentru clienții din Mureș, Harghita și Bistrița-Năsăud. Lucrăm la extinderea acesteia pentru toți partenerii, în cel mai scurt timp.</p>
        <p><b>Îți mulțumim pentru înțelegere și răbdare!</b></p>
      </div>
    </div>
  );
};

export default TrackingFeatureWarning;
